import axiosInstance from "../Middleware/interceptor";
import { toast } from "react-toastify";


export const postApi = async (url, data, headers = {}, showSuccessToast = true) => {
  try {
    const config = {
      headers: {
        'accept': 'application/json',
        'Accept-Language': 'en', // Default to English, can be overridden
        'Content-Type': 'application/json',
        ...headers
      }
    };
    const response = await axiosInstance.post(`${url}`, data, config);
    if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
      if (showSuccessToast && response?.data?.message) {
      toast.success(response?.data?.message);  // Success toast
      }
    } else {
      // Handle non-200 status codes
      const errorMessage = response?.data?.message || response?.data?.error || 'An error occurred';
      toast.error(errorMessage);
    }

    return response?.data;
  } catch (error) {
    // Catching any error (e.g., 500 internal server error) and showing it as a toast
    if (error?.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      const statusCode = error.response.status;
      const errorData = error.response.data;
      
      let errorMessage = 'An error occurred';
      
      if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (errorData?.error) {
        errorMessage = errorData.error;
      } else if (statusCode === 400) {
        errorMessage = 'Invalid request. Please check your input.';
      } else if (statusCode === 401) {
        errorMessage = 'Invalid email or password. Please try again.';
      } else if (statusCode === 403) {
        errorMessage = 'Access denied. Please contact administrator.';
      } else if (statusCode === 404) {
        errorMessage = 'Service not found. Please try again later.';
      } else if (statusCode === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (statusCode >= 500) {
        errorMessage = 'Server error. Please try again later.';
      } else {
        errorMessage = errorData?.message || 'An unexpected error occurred';
      }
      
      toast.error(errorMessage);
    } else if (error?.request) {
      // The request was made but no response was received
      toast.error('Unable to connect to server. Please check your internet connection and try again.');
    } else {
      // Something else happened while setting up the request
      toast.error(`Error: ${error?.message || 'An unexpected error occurred'}`);
    }

    throw error; // Re-throw the error to propagate it further if necessary
  }
};

export const getApi = async (url) => {
  try {
    const response = await axiosInstance.get(`${url}`);
    if(response?.data?.statusCode === 200){
      // toast.success(response?.data?.message)
      } else{
        toast.error(response?.data?.message)
      }
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const putApi = async (url, data) => {
  try {
    const response = await axiosInstance.put(`${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, data) => {
  try {
    const response = await axiosInstance.delete(`${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};